import { TextboxControlWithDatePicker } from "@/Common/Components/Inputs/TextboxControlWithDatePicker";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { DateTimeWithPrecision } from "@/Common/Models/DateTimeWithPrecision";
import { LifeStageDatePrecisionEnum } from "@/Common/Models/LifeStageDatePrecisionEnum";
import { LifeStageModeEnum } from "@/Patient/Models/LifeStageModeEnum";

interface ILifeStageStartDateModeProps {
    lifeStageDatePrecision: LifeStageDatePrecisionEnum;
    lifeStageDateTextboxValue: string;
    lifeStageStartDate: Date;
    lifeStageIsStartDateApprox: boolean;
    useThreeCols: boolean;
    onLifeStageDateChange: (date: DateTimeWithPrecision, precision: LifeStageDatePrecisionEnum) => void;
    onLifeStageModeClick: (newMode: LifeStageModeEnum) => void;
    onLifeStageDateApproxChange: () => void;
    onLifeStageDateTodayClick: () => void;
}

function LifeStageStartDateMode(props: ILifeStageStartDateModeProps): JSX.Element {
    const { getText } = useTranslation();

    const disabled = props.lifeStageDatePrecision != null && (
        props.lifeStageDatePrecision == LifeStageDatePrecisionEnum.MonthYear ||
        props.lifeStageDatePrecision == LifeStageDatePrecisionEnum.Year
    );

    const renderLifeStageModeButtons = (): JSX.Element => (
        <>
            <a className="pointer" onClick={() => props.onLifeStageModeClick(LifeStageModeEnum.Age)}>
                <span>
                    {getText("AgeAtOnsetLabel")}
                </span>
            </a>
            {" | "}
            <a className="pointer" onClick={() => props.onLifeStageModeClick(LifeStageModeEnum.LifeStage)}>
                <span>
                    {getText("LifeStageDLabel")}
                </span>
            </a>
        </>
    );

    return (
        <tr key="startdate">
            <td className="c1">
                <span>{getText("StartDateLabel")}</span>
            </td>
            <td className="c2">
                <div className="flex-container flex-start">
                    <TextboxControlWithDatePicker
                        id="lifestageDP"
                        dataCy="medicalItems-medicalReaction-startDate"
                        textValue={props.lifeStageDateTextboxValue}
                        dateValue={props.lifeStageStartDate}
                        onChange={(datePrecision: DateTimeWithPrecision) => {
                            props.onLifeStageDateChange(datePrecision, datePrecision.precision);
                        }}
                    />
                    <div className="padding-sm-left pointer margin-xs-top">
                        <input
                            disabled={disabled}
                            type="checkbox"
                            onChange={() => props.onLifeStageDateApproxChange()}
                            checked={props.lifeStageIsStartDateApprox}
                        />
                        <span onClick={() => props.onLifeStageDateApproxChange()}>Approx.</span>
                    </div>
                    <div className="padding-sm-left pointer" style={{ "marginTop": "7px" }}>
                        <a
                            onClick={() => props.onLifeStageDateTodayClick()}
                            data-cy="medicalItems-medicalReaction-startDate-today"
                        >
                            <span>
                                {getText("TodayLabel")}
                            </span>
                        </a>
                    </div>
                </div>
            </td>
            {props.useThreeCols && (
                <td className="c3" colSpan={2}>
                    {renderLifeStageModeButtons()}
                </td>
            )}
            {!props.useThreeCols && (
                <>
                    <td className="c3" />
                    <td className="c4" data-cy="medicalItems-medicalReaction-lifeStage-modes">
                        {renderLifeStageModeButtons()}
                    </td>
                </>
            )}
        </tr>
    );
}

export { LifeStageStartDateMode };
